<template>
  <el-dialog :title="$t('newHotel')" :visible="isShowDialog" @close="closePopup()" width="600px">
    <span id="modal-body">
      <el-form ref="form" label-width="150px" style="width: 500px">
        <el-form-item :label="$t('hotelName')" :required="true">
          <el-input v-model="hotel.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('hotelCode')" :required="true">
          <el-input class="text-uppercase" v-model="hotel.code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-radio-group v-model="hotel.isEnable" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onAddHotelButtonClick">{{ $t('create') }}</el-button>
      <el-button type="default" @click="closePopup">{{ $t('cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { STATUS } from '@/configs/constant'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import HotelApi from '@/api/hotel-api'
import i18nMessages from '@/translations/Hotel/components/PopupAddHotel.i18n'

export default {
  name: 'PopupAddHotel',
  i18n: { messages: i18nMessages },
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      STATUS,
      hotel: {
        code: '',
        name: '',
        isEnable: STATUS.ENABLE
      },
      isShowDialog: false
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
    }
  },
  methods: {
    onAddHotelButtonClick: async function () {
      try {
        this.startLoading()

        this.hotel.code = this.hotel.code.toUpperCase()
        const result = await HotelApi.create(this.hotel)
        const title = 'Success'
        const message = 'Add Hotel Success.'

        this.$emit('onAdded', result)
        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.closePopup()
      this.clear()
      this.stopLoading()
    },
    closePopup: function () {
      this.isShowDialog = false
      this.$emit('onClose')
    },
    clear: function () {
      this.hotel.code = ''
      this.hotel.name = ''
      this.hotel.isEnable = 1
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
